import { PageHero } from '../components/PageHero'
import { Link } from 'react-router-dom'

const hospitalGroups = [
  { title: 'Public hospitals', hospitals: [
    { name: 'Peking Union Medical College Hospital', city: 'Beijing', url: 'https://www.pumch.cn/en/new_about.html' },
    { name: 'West China Hospital', city: 'Chengdu', url: 'https://www.wchscu.cn/home.html' },
    { name: 'Huashan Hospital', city: 'Shanghai', url: 'https://www.huashan.org.cn/' },
    { name: 'Ruijin Hospital', city: 'Shanghai', url: 'https://www.rjh.com.cn/' },
    { name: 'Zhongshan Hospital', city: 'Shanghai', url: 'https://www.zs-hospital.sh.cn/' },
    { name: 'Beijing Tiantan Hospital', city: 'Beijing', url: 'https://www.bjtth.cn/' },
  ] },
  { title: 'Private hospitals', hospitals: [
    { name: 'Beijing United Family Hospital', city: 'Beijing', url: 'https://beijing.ufh.com.cn/?lang=en' },
    { name: 'Amcare Women’s & Children’s Hospital', city: 'Beijing', url: 'https://www.amcare.com.cn/' },
    { name: 'DeltaHealth Hospital Shanghai', city: 'Shanghai', url: 'https://www.deltahealth.com.cn/en/pages/single/about' },
    { name: 'Jiahui International Hospital', city: 'Shanghai', url: 'https://jiahui.com/en/locations/JIH' },
    { name: 'Shanghai SinoUnited Hospital', city: 'Shanghai', url: 'https://suhhealth.com/' },
    { name: 'Raffles Hospital Beijing', city: 'Beijing', url: 'https://www.rafflesmedicalchina.com/en/site/beijing-hospital/' },
  ] },
]

export function About() {
  return <div className="about-page">
    <PageHero eyebrow="About China Care" title="A conversation about care in China." text="You’ve probably done a lot of the work already: the reading, the comparing, the late-night searching. What’s harder to come by is judgment, a sense of what care in China would actually mean for your situation. Here’s a little about us, the perspective we bring, and why we believe we can help you make sense of it." />

    <div className="about-story section-pad">
      <section aria-labelledby="about-why">
        <p className="eyebrow">Why China Care</p>
        <h2 id="about-why">Between an idea and an appointment, there are a lot of questions.</h2>
        <p>You may have heard about medical care in China, or already have a hospital in mind. But a hospital website can only tell you so much. Who can you speak to about your situation? How will you explain it in another language? What would travelling for care actually involve?</p>
        <p>We started China Care to help you navigate those questions. We help you begin a conversation with doctors in China and make sense of the arrangements around it, so you can take the next step with a clearer picture.</p>
      </section>

      <section aria-labelledby="about-who">
        <p className="eyebrow">Who we are</p>
        <h2 id="about-who">Roots in China. Experience abroad.</h2>
        <p>We are a Chinese team with years of experience living and working overseas. We understand healthcare systems in China and abroad, and what it feels like to navigate care in another country.</p>
        <p>Our connections with doctors and hospital teams in China help us connect you with people who can discuss your case. Alongside that local knowledge, our experience abroad helps us understand your questions, expectations and the practical details of travelling for care.</p>
        <p>China Care is an independent coordination service for people considering non-emergency medical care in China. We bring those connections, language support and local experience together around your needs. Explore our <Link to="/how-we-help">patient coordination support</Link> and <Link to="/how-it-works">three-stage care journey</Link>.</p>
        <p className="about-role">We coordinate your journey. Licensed doctors and hospitals provide medical advice and care.</p>
      </section>

      <section aria-labelledby="about-access">
        <p className="eyebrow">Hospital access</p>
        <h2 id="about-access">Access to leading hospitals in China.</h2>
        <p>We help you explore access to specialists and care at leading public and private hospitals in China, including:</p>
        <div className="about-hospitals">
          {hospitalGroups.map(group => <div key={group.title}>
            <h3>{group.title}</h3>
            <ul>{group.hospitals.map(hospital => <li key={hospital.name}>
              <a href={hospital.url} target="_blank" rel="noopener noreferrer">{hospital.name}</a>
              <span>{hospital.city}</span>
            </li>)}</ul>
            <p className="about-hospitals-more"><em>and more</em></p>
          </div>)}
        </div>
        <p className="about-role about-access-note">Hospital and specialist options depend on your needs and availability, and are confirmed individually.</p>
      </section>

      <section className="about-email" aria-labelledby="about-contact">
        <h2 id="about-contact">Email contact</h2>
        <p>If needed, you can email us at <a href="mailto:info@chinacare.cc">info@chinacare.cc</a>.</p>
      </section>
    </div>

  </div>
}
